import { useEffect } from 'react';
export default function useEscape(_ref) {
  var unless = _ref.unless,
    onPress = _ref.onPress;
  useEffect(function () {
    function handleOnPress(e) {
      var shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;
      if (shouldNotExecute || e.key !== 'Escape') {
        return;
      }
      onPress(e);
    }
    document.addEventListener('keyup', handleOnPress);
    return function () {
      document.removeEventListener('keyup', handleOnPress);
    };
  }, [unless]);
}